<template>
  <div class="wrap">
    <!-- <HeaderTop color="#7adbbf">自定义电价</HeaderTop> -->
    <div class="header">自定义电价</div>
    <div class="content" v-if="electrovalence.length > 0">
      <div class="warp" v-for="(item,index) in electrovalence" :key="index">
        <div class="content-wrap">
          <div class="content-one">
            <div class="content-one-text">{{index + 1}}.电价类型:</div>
            <input class="content-one-input" type="text" v-model="item.tpyeName" />
            <!-- <div class="content-one-input"> {{item.tpyeName}}</div> -->

            <img src="../../assets/imgs/mistake.png" class="imgs" @click="deleteGenre(item)" />
          </div>
        </div>
        <!-- <div class="amend">
          <img src="../../assets/imgs/amend.png" @click="amendGenre(item)" />
        </div>-->
        <div class="content-wrap content-wraps">
          <div class="content-one">
            <div class="content-one-text">电价:</div>
            <input
              class="content-one-input line-input"
              type="txt"
              onkeyup="value=value.replace(/[^0-9]/g,'')"
              v-model="item.priceMoney"
            />
            <div class="content-one-texts">/度电</div>
            <img src="../../assets/imgs/save.png" class="save" @click="addGenre(item)" />
          </div>
        </div>
      </div>
    </div>

    <div class="img-wrap" @click="genres">
      <img src="../../assets/imgs/zdydj.png" alt />
      <div class="img-wrap-text">添加电价类型</div>
    </div>
  </div>
</template>

<script>
import {
  electrovalenceList,
  addElectrovalence,
  amendElectrovalence,
  deleteElectrovalence
} from "../../api";
import { Toast } from "vant";
import HeaderTop from "../../components/HeaderTop.vue";

export default {
  name: "CommonProblems",
  data() {
    return {
      electrovalence: [],
      types: "",
      price: "",
      adminId: "",
      isShow: false
    };
  },
  components: {
    HeaderTop
  },
  methods: {
    //点击添加点击类型
    genres() {
      let tpyeName = "";
      let priceMoney = "";
      let obj = {};
      this.electrovalence.push(obj);
      this.isShow = true;
    },
    //添加电价类型
    addGenre(item) {
      let that = this;
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: "提示",
        content: "是否添加电价",
        confirmBtn: {
          text: "确定",
          active: true,
          disabled: false,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取消",
          active: false,
          disabled: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          let adminId = that.adminId;
          let priceMoney = item.priceMoney;
          let tpyeName = item.tpyeName;
          addElectrovalence(adminId, priceMoney, tpyeName)
            .then(res => {
              if (res.status == 1) {
                that.isShow = false;
                Toast.success("添加电价成功");
                that.$router.push({ path: `/getCommission` });
              } else {
                Toast.fail(res.msg);
              }
            })
            .catch(err => {});
        },
        onCancel: () => {
          this.$createToast({
            type: "warn",
            time: 1000,
            txt: "点击取消按钮"
          }).show();
        }
      }).show();
    },
    //删除电价类型
    deleteGenre(item) {
      let that = this;
      if (this.isShow) {
        Toast.fail("请您先保存信息！");
        return;
      }
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: "提示",
        content: "是否删除电价",
        confirmBtn: {
          text: "确定",
          active: true,
          disabled: false,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取消",
          active: false,
          disabled: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          let priceTypeId = item.id;
          deleteElectrovalence(priceTypeId)
            .then(res => {
              if (res.code == 0) {
                that.isShow = false;
                Toast.success("删除电价成功");
                that.genreList();
              } else {
                Toast.fail(res.msg);
              }
            })
            .catch(err => {});
        },
        onCancel: () => {
          this.$createToast({
            type: "warn",
            time: 1000,
            txt: "点击取消按钮"
          }).show();
        }
      }).show();
    },
    //修改电价类型
    amendGenre(item) {
      let that = this;
      if (this.isShow) {
        Toast.fail("请您先保存信息！");
        return;
      }
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: "提示",
        content: "是否修改电价",
        confirmBtn: {
          text: "确定",
          active: true,
          disabled: false,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取消",
          active: false,
          disabled: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          let id = item.id;
          let adminId = that.adminId;
          let priceMoney = item.priceMoney;
          let tpyeName = item.tpyeName;
          amendElectrovalence(id, adminId, priceMoney, tpyeName)
            .then(res => {
              if (res.status == 1) {
                that.isShow = false;
                Toast.success("修改电价成功");
                that.genreList();
              } else {
                Toast.fail(res.msg);
              }
            })
            .catch(err => {});
        },
        onCancel: () => {
          this.$createToast({
            type: "warn",
            time: 1000,
            txt: "点击取消按钮"
          }).show();
        }
      }).show();
    },
    //电价列表
    async genreList() {
      let adminId = sessionStorage.getItem("userID");
      let result = await electrovalenceList(adminId);
      if (result.status == 1) {
        this.electrovalence = result.data;
      }
    }
  },
  mounted() {
    this.adminId = sessionStorage.getItem("userID");
    this.genreList();
  }
};
</script>

<style scoped lang="less">
.wrap {
  width: 100%;
  overflow-y: hidden;
  position: relative;
  height: 100%;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 0.45rem;
    font-size: 0.15rem;
    line-height: 0.45rem;
    display: flex;
    justify-content: center;
    color: white;
    // position: fixed;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 50;
    box-sizing: border-box;
    // color: #7adbbf;
    background-color: rgb(122, 219, 191);
  }
  .content {
    box-sizing: border-box;
    margin-top: 0.4rem;
    height: 75%;
    overflow-y: auto;
    .warp {
      border: 0.01rem solid #fff;
      position: relative;
      margin-bottom: 0.2rem;
      .amend {
        position: absolute;
        right: 0.38rem;
        top: 0.55rem;
      }
      .content-wrap {
        width: 90%;
        margin-top: 0.2rem;
        .content-one {
          margin-left: 0.35rem;
          display: flex;
          align-items: center;
          .imgs {
            margin-left: 0.4rem;
          }

          .content-one-text {
            width: 2rem;
            font-size: 0.15rem;
            color: #666;
            text-align: end;
          }
          .content-one-input {
            margin-left: 0.1rem;
            width: 1.35rem;
            height: 0.25rem;
            border: 1px solid #e4e3e4;
            border-radius: 4px;
            font-size: 0.14rem;
          }
          .line-input {
            margin-left: 0.1rem;
            width: 0.8rem;
          }
          .content-one-texts {
            width: 2rem;
            font-size: 0.14rem;
            color: #e0e0e1;
            margin-left: 0.1rem;
          }
        }
      }
      .content-wraps {
        width: 90%;
        margin-top: 0.2rem;
        // margin-left: -0.12rem;
      }
    }
  }
  .img-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    // margin-top: 40%;
    position: absolute;
    bottom: 0.1rem;
    left: 40%;
    img {
      width: 0.7rem;
      height: 0.7rem;
    }
    .img-wrap-text {
      font-size: 0.15rem;
      color: #aeaeaf;
      margin-top: 0.1rem;
    }
  }
}
</style>
